module.exports = __webpack_public_path__ + "static/media/sn_h_tg.2e80bf83.svg";